export default __webpack_public_path__ + "static/5-e3331d57f56834167eb99df59abb0cbc.png";